// extracted by mini-css-extract-plugin
module.exports = {"root":"InboxNav_root__-8M72","tab":"InboxNav_tab__1sp_X"};